import { render, staticRenderFns } from "./GatherJobDetails.vue?vue&type=template&id=06cedbd0&scoped=true&"
import script from "./GatherJobDetails.vue?vue&type=script&lang=js&"
export * from "./GatherJobDetails.vue?vue&type=script&lang=js&"
import style0 from "./GatherJobDetails.vue?vue&type=style&index=0&id=06cedbd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cedbd0",
  null
  
)

export default component.exports